import { Text } from "react-native";
import { TextInput } from "react-native";
import { useSlot, useStyled } from "use-styled";

const InputRoot = useStyled(TextInput, {
  base: {
    className:
      "flex-1 text-teachLoop-textPrimary font-geologica-regular border border-gray-200 bg-teachLoop-creamLight rounded-[17] focus:outline-teal-600 placeholder:text-gray-400",
  },
  variants: {
    size: {
      md: { className: "text-base leading-[1.5] px-4 py-3" },
    },
    error: {
      true: { className: "border-red-500" },
      false: {},
    },
    disabled: {
      true: { className: "opacity-50" },
    },
  },
  defaultVariants: {
    size: "md",
  },
  compoundVariants: [
    {
      disabled: true,
      props: {
        disabled: true,
      },
    },
  ],
});

const InputMessage = useStyled(Text, {
  base: {
    className: "font-geologica-regular font-normal text-sm text-[#A0AEC0] leading-[1.5] mx-4",
  },
});

export const Input = useSlot(InputRoot, {
  Message: InputMessage,
});
